import { Action } from "redux";
import {LoadingStatus} from "../../status";
import {SiloGroupAPIResponse, SiloGroupTypesAPIResponse} from "./stateTypes";

export enum SiloGroupAT {
    FETCH_SILO_CONFIG_REQUEST = "silo_group/FETCH_CONFIG_REQUEST",
    FETCH_SILO_CONFIG_SUCCESS = "silo_group/FETCH_CONFIG_SUCCESS",
    FETCH_SILO_CONFIG_FAILURE = "silo_group/FETCH_CONFIG_FAILURE",

    SAVE_SILO_CONFIG_REQUEST = "silo_group/SAVE_CONFIG_REQUEST",
    SAVE_SILO_CONFIG_SUCCESS = "silo_group/SAVE_CONFIG_SUCCESS",
    SAVE_SILO_CONFIG_FAILURE = "silo_group/SAVE_CONFIG_FAILURE",
    SET_LOADING_STATE = "silo_group/SET_LOADING_STATE",

    FETCH_SILO_GROUP_TYPE_REQUEST = "silo_group/FETCH_SILO_GROUP_TYPE_REQUEST",
    FETCH_SILO_GROUP_TYPE_SUCCESS = "silo_group/FETCH_SILO_GROUP_TYPE_SUCCESS",
    FETCH_SILO_GROUP_TYPE_FAILURE = "silo_group/FETCH_SILO_GROUP_TYPE_FAILURE",
}

// Interface for Fetch Request Action
export interface FetchSiloConfigAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.FETCH_SILO_CONFIG_REQUEST;
    payload: number
}
export interface FetchSiloConfigSuccessAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.FETCH_SILO_CONFIG_SUCCESS;
     payload: {  configData: SiloGroupAPIResponse };
}

export interface FetchSiloConfigFailureAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.FETCH_SILO_CONFIG_FAILURE;
    payload: { error: any };
}

// Interface for Save Request Action
export interface SaveSiloConfigAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.SAVE_SILO_CONFIG_REQUEST;
    payload: { devicePk: number, payload: any };
}

// 5. SAVE SUCCESS: Receives the response from the server after saving
export interface SaveSiloConfigSuccessAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.SAVE_SILO_CONFIG_SUCCESS;
    payload: { response: any };
}

// 6. SAVE FAILURE: Receives the error object
export interface SaveSiloConfigFailureAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.SAVE_SILO_CONFIG_FAILURE;
    payload: { error: any };
}

export interface SetSiloGroupLoadingStatusAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.SET_LOADING_STATE;
    payload: LoadingStatus;
}

export interface FetchSiloGroupTypesAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.FETCH_SILO_GROUP_TYPE_REQUEST;
}

export interface FetchSiloGroupTypesSuccessAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.FETCH_SILO_GROUP_TYPE_SUCCESS;
     payload: {  groupTypes: SiloGroupTypesAPIResponse };
}

export interface FetchSiloGroupTypesFailureAI extends Action<SiloGroupAT> {
    type: SiloGroupAT.FETCH_SILO_GROUP_TYPE_FAILURE;
    payload: { error: any };
}